import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { timer } from 'rxjs';
import { Router } from '@angular/router';

import { SecurityService } from '../security/security.service';

@Component({
	selector: 'pcg-inactivity-timeout',
	templateUrl: './inactivity-timeout.component.html',
	styleUrls: ['./inactivity-timeout.component.scss'],
	standalone: true,
	imports: [],
})
export class InactivityTimeoutComponent implements OnInit, OnDestroy {
	public modal = inject(NgbActiveModal);
	private http = inject(HttpClient);
	private sec = inject(SecurityService);
	private router = inject(Router);

	subscribeTimer!: number;

	get timeLeft() {
		const now: any = new Date();
		if (localStorage.getItem('lastAccess')) {
			const lastAccess: any = new Date(JSON.parse(localStorage.getItem('lastAccess')!));
			const theTimeLeft = 300 - (now - lastAccess) / 1000;
			return Number.parseInt(theTimeLeft.toString(), 10);
		} else {
			return 0;
		}
	}

	ngOnInit() {
		this.subscribeTimer = this.timeLeft;
		const source = timer(0, 1000);
		source.subscribe(() => {
			this.subscribeTimer = this.timeLeft;
			if (this.subscribeTimer <= 0) {
				// Times up
				// Nullify token, security, and user info
				this.sec.setSecurity(null!, null!, null!);

				// Close this modal
				this.modal.dismiss();

				// Redirect to login
				let redirectUrl = '';
				const redirect = globalThis.location.href.replace(document.getElementsByTagName('base')[0].href, '');
				if (decodeURIComponent(redirect).includes('login?redirectUrl=')) {
					return;
				}

				if (redirect !== null && redirect !== '' && redirect !== undefined) {
					redirectUrl = '/' + redirect;
				}

				if (redirectUrl == null) {
					this.router.navigateByUrl(`/login`);
				} else {
					this.router.navigateByUrl(`/login?redirectUrl=${encodeURIComponent(redirectUrl)}`);
				}
			} else if (this.subscribeTimer > 30) {
				this.modal.dismiss();
			} // Session was probably extended in another window
		});
	}

	ngOnDestroy() {
		const user = this.sec.getUser();
		// Need to do a server hit to reset timeout server-side
		if (user && this.timeLeft <= 30) {
			this.http.get(`/api/Account/GetUserInfo/${user.id}`).subscribe();
		}
	}
}
